import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_SERVICES = "SET_SERVICES";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setServices(services) {
  return {
    type: SET_SERVICES,
    payload: services,
  };
}

export function createService(token, serviceData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/services`, serviceData, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      await dispatch(getServices(token));
      await callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getServices(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/services`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setServices(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function updateService(token, service, updateData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/services/${service}`,
        updateData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(getServices(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
